// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customBorderRadius[data-v-74607b26]{border-radius:12px!important}.h-100[data-v-74607b26]{height:100%}", ""]);
// Exports
module.exports = exports;
